import Vue from 'vue';
import Router from 'vue-router';
import ShioriAbout from './components/ShioriAbout.vue';
import ShioriItems from './components/ShioriItems.vue';
import ShioriTitle from './components/ShioriTitle.vue';
import ShioriSchedule from './components/ShioriSchedule.vue';
import HowTo from './components/HowTo.vue';
import Kyouyu from './components/Kyouyu.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', component:ShioriTitle}, 
    {path: '/about', component:ShioriAbout}, 
    {path: '/items', component:ShioriItems}, 
    {path: '/schedule', component:ShioriSchedule},
    {path: '/howto', component:HowTo},
    {path: '/kyouyu', component:Kyouyu}
  ]
});